import _ from "lodash";
import React from "react";
import classes from "./EvaluationStatus.scss";
import { colors } from "Constants";
import { ASSESSMENT_TOOLS } from "@toddle-edu/common-utils";
import I18nHOC from "UIComponents/I18nHOC";
import { TickCircleFilled } from "@toddle-edu/ds-icons";
import {
  ASSESSMENT_GRADE_BOUNDARY,
  ASSESSMENT_AUTO_EVALUATE_CATEGORY_GRADE_BOUNDARY,
  ASSESSMENT_AUTO_EVALUATE_CUSTOM_GRADE_BOUNDARY,
  ASSESSMENT_AUTO_EVALUATE_TERM_GRADE_BOUNDARY,
  SINGLE_POINT_RUBRIC,
  COMMENT,
  SCORE,
  DP_ASSESSMENT_RUBRIC,
  SCORE_BASED_RUBRIC,
  STANDARD_BASED_RUBRIC,
  GRADE_SCALE_TOOL,
} from "Constants/stringConstants";
import classNames from "classnames";

const styles = {
  aiEvaluationStatus: {
    backgroundColor: "var(--interactive-tertiary)",
  },
  aiEvaluationStatusIcon: {
    color: "var(--interactive-tertiary)",
  },
};

const HIDE_EVAL_STATUS_TOOLS = [
  COMMENT,
  SCORE,
  GRADE_SCALE_TOOL,
  DP_ASSESSMENT_RUBRIC,
  ASSESSMENT_GRADE_BOUNDARY,
  ASSESSMENT_AUTO_EVALUATE_CATEGORY_GRADE_BOUNDARY,
  ASSESSMENT_AUTO_EVALUATE_CUSTOM_GRADE_BOUNDARY,
  ASSESSMENT_AUTO_EVALUATE_TERM_GRADE_BOUNDARY,
];

const EvaluationStatus = ({
  isEvaluatedByStudent,
  t,
  toolType,
  isEvaluatedByTeacher,
  userType,
  evaluationStatusIconSize = "xx-small",
  isSplitView = false,
  evaluationInstructionContainerStyle = {},
  teacherEvaluationText,
  studentEvaluationText,
  evaluationInstructionItemStyle = {},
  shouldShowEvaluationStatus = true,
  tickStyles = {},
  shouldShowEvaluationStatusWithTitle = false,
  evaluationInstructionNormalStyle = {},
  isEvaluatedByAI = false,
}) => {
  // const isRubric = toolType === "RUBRIC";
  // const isChecklist = toolType === "CHECKLIST";
  const hasEvaluation = _.get(
    _.find(ASSESSMENT_TOOLS, { type: toolType }),
    "hasEvaluation",
    false
  );

  const localeLabel = _.get(
    _.find(ASSESSMENT_TOOLS, { type: toolType }),
    "locale",
    false
  );

  const hollowTick = isSplitView || toolType == SINGLE_POINT_RUBRIC;

  const showEvaluationStatus =
    hasEvaluation &&
    (isEvaluatedByStudent || isEvaluatedByTeacher) &&
    !_.includes(HIDE_EVAL_STATUS_TOOLS, toolType) &&
    shouldShowEvaluationStatus;

  const evaluationInstructionNormalClass = classNames({
    [classes.evaluationInstructionNormal]: true,
    [classes.splitEvaluationInstructionNormal]: isSplitView,
    ["text-body-1"]: shouldShowEvaluationStatusWithTitle,
  });

  const evalutionStatusElement = showEvaluationStatus ? (
    <div
      className={classes.evaluationInstructionContainer}
      style={evaluationInstructionContainerStyle}
    >
      {/* Student */}
      {isEvaluatedByStudent ? (
        <div
          className={classes.evaluationInstructionItem}
          style={evaluationInstructionItemStyle}
        >
          {hollowTick ? (
            <div
              className={classes.tickSvgComponent}
              style={{ backgroundColor: colors.neutral200, ...tickStyles }}
            />
          ) : (
            <TickCircleFilled size={evaluationStatusIconSize} />
          )}
          <div
            className={evaluationInstructionNormalClass}
            style={evaluationInstructionNormalStyle}
          >
            {studentEvaluationText
              ? studentEvaluationText
              : userType === "student"
              ? t("common:your_evaluation")
              : t("common:student_evaluation")}
          </div>
        </div>
      ) : null}

      {/* Teacher */}

      {isEvaluatedByTeacher ? (
        <div
          className={classes.evaluationInstructionItem}
          style={evaluationInstructionItemStyle}
        >
          {hollowTick ? (
            <div
              className={classes.tickSvgComponent}
              style={{ backgroundColor: colors.blue400, ...tickStyles }}
            />
          ) : (
            <TickCircleFilled
              size={evaluationStatusIconSize}
              variant={"link"}
            />
          )}

          <div className={evaluationInstructionNormalClass}>
            {teacherEvaluationText
              ? teacherEvaluationText
              : t("common:teacher_evaluation")}
          </div>
        </div>
      ) : null}

      {/* AI */}

      {isEvaluatedByAI ? (
        <div
          className={classes.evaluationInstructionItem}
          style={evaluationInstructionItemStyle}
        >
          {hollowTick ? (
            <div
              className={classes.tickSvgComponent}
              style={{
                ...styles.aiEvaluationStatus,
                ...tickStyles,
              }}
            />
          ) : (
            <TickCircleFilled
              size={evaluationStatusIconSize}
              style={styles.aiEvaluationStatusIcon}
            />
          )}

          <div className={evaluationInstructionNormalClass}>
            {/* TODO: localize */}
            {"AI"}
          </div>
        </div>
      ) : null}
    </div>
  ) : null;

  if (shouldShowEvaluationStatusWithTitle) {
    const evaluationStatusClasses = classNames({
      [classes.evalutionStatusWithToolTitle]: true,
      [classes.removeBottomMargin]: _.includes(
        [ASSESSMENT_GRADE_BOUNDARY],
        toolType
      ),
      // show evaluation below the label
      [classes.standardRubric]: _.includes(
        [SCORE_BASED_RUBRIC, STANDARD_BASED_RUBRIC],
        toolType
      ),
    });

    return (
      <div className={evaluationStatusClasses}>
        <div className={"text-label-l"}>{t(localeLabel)}</div>
        {evalutionStatusElement}
      </div>
    );
  }

  return evalutionStatusElement;
};

export default I18nHOC({ resource: "common" })(EvaluationStatus);
